import * as routes from 'src/app/onboarding/routes';

export const goLogout = (params: { callbackUrl?: string } = {}) => {
  window.location.href = routes.logoutRouteConfig.path(params);
};
